module.exports = __webpack_public_path__ + "static/img/9.72e8f25.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/1/zh/9.png
// module id = aGW2
// module chunks = 0